module.exports = __webpack_public_path__ + "img/play.e1141994.svg";